import { useState } from "react";

import "../styles/FoodManagementPage.css";

import useFoods from "../hooks/useFoods";
import useFoodFilters from "../hooks/useFoodFilters";

import FoodHeader from "../components/FoodHeader/FoodHeader";
import FoodStats from "../components/FoodStats/FoodStats";
import FoodToolbar from "../components/FoodToolbar/FoodToolbar";
import FoodGrid from "../components/FoodGrid/FoodGrid";
import EmptyFoods from "../components/EmptyFoods/EmptyFoods";

import AddFoodModal from "../components/AddFoodModal/AddFoodModal";
import EditFoodModal from "../components/EditFoodModal/EditFoodModal";
import DeleteFoodModal from "../components/DeleteFoodModal/DeleteFoodModal";
import FoodDetailsModal from "../components/FoodDetailsModal/FoodDetailsModal";

function FoodManagementPage() {

  const {
    foods,
    loading,
    error,
    addFood,
    updateFood,
    deleteFood,
     toggleAvailability,
  } = useFoods();

  const {
    filteredFoods,

    search,
    setSearch,

    category,
    setCategory,

    dietType,
    setDietType,

    availability,
    setAvailability,

    sortBy,
    setSortBy,

  } = useFoodFilters(foods);

  const [showAddModal, setShowAddModal] = useState(false);

  const [editingFood, setEditingFood] = useState(null);

  const [deletingFood, setDeletingFood] = useState(null);

  const [selectedFood, setSelectedFood] = useState(null);

  return (

    <div className="food-management-page">

      <FoodHeader
        onAddFood={() => setShowAddModal(true)}
      />

      <FoodStats foods={foods} />

      <FoodToolbar
        search={search}
        setSearch={setSearch}

        category={category}
        setCategory={setCategory}

        dietType={dietType}
        setDietType={setDietType}

        availability={availability}
        setAvailability={setAvailability}

        sortBy={sortBy}
        setSortBy={setSortBy}
      />

      {error && (
        <div className="food-error">
          {error}
        </div>
      )}

      {filteredFoods.length === 0 ? (

        <EmptyFoods
          onAddFood={() =>
            setShowAddModal(true)
          }
        />

      ) : (

        <FoodGrid
          foods={filteredFoods}

          onView={setSelectedFood}

          onEdit={setEditingFood}

          onDelete={setDeletingFood}
          onToggleAvailability={toggleAvailability}
        />

      )}

      {/* Add */}

      <AddFoodModal

        open={showAddModal}

        onClose={() =>
          setShowAddModal(false)
        }

        loading={loading}

        onSubmit={async (data) => {

          const success = await addFood(data);

          if (success) {

            setShowAddModal(false);

          }

        }}

      />

      {/* Edit */}

      <EditFoodModal

        open={!!editingFood}

        food={editingFood}

        loading={loading}

        onClose={() =>
          setEditingFood(null)
        }

        onSubmit={async (id, data) => {

          const success =
            await updateFood(id, data);

          if (success) {

            setEditingFood(null);

          }

        }}

      />

      {/* Delete */}

      <DeleteFoodModal

        open={!!deletingFood}

        food={deletingFood}

        loading={loading}

        onClose={() =>
          setDeletingFood(null)
        }

        onDelete={async (id) => {

          const success =
            await deleteFood(id);

          if (success) {

            setDeletingFood(null);

          }

        }}

      />

      {/* Details */}

      <FoodDetailsModal

        open={!!selectedFood}

        food={selectedFood}

        onClose={() =>
          setSelectedFood(null)
        }

      />

    </div>

  );

}

export default FoodManagementPage;